import { Component } from '@angular/core';
import { BaseComponent } from '../../../../../base/base.component';

@Component({
  selector: 'app-track-bottom-toolbar',
  templateUrl: './track-bottom-toolbar.component.html',
  styleUrl: './track-bottom-toolbar.component.scss',
  standalone: false,
})
export class TrackBottomToolbarComponent extends BaseComponent {}
